import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MailWarning, Cake, Award, ArrowRight } from "lucide-react";
import api from "@/lib/api";

const when = (d) => (d === 0 ? "Today" : d === 1 ? "Tomorrow" : `In ${d} days`);

// Admin/HR: staff celebrating in the next 7 days who won't get the greeting email.
export default function MissingEmailCard() {
    const [rows, setRows] = useState(null);

    useEffect(() => {
        api.get("/dashboard/celebrations-week")
            .then(({ data }) => setRows((data.items || []).filter((it) => !it.has_email)))
            .catch(() => setRows([]));
    }, []);

    if (!rows || rows.length === 0) return null;
    return (
        <div className="mt-8 bg-white border border-ink/10 p-6 sm:p-8" data-testid="missing-email-card">
            <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-terracotta-50 text-terracotta-500 flex items-center justify-center shrink-0"><MailWarning className="w-6 h-6" /></div>
                <div>
                    <div className="overline">Celebration emails</div>
                    <div className="mt-1 font-display font-bold text-xl text-ink" data-testid="missing-email-count">
                        {rows.length} upcoming celebration{rows.length === 1 ? "" : "s"} with no email on file
                    </div>
                    <p className="text-sm text-ink/55">Add an email in the next 7 days so their greeting goes out.</p>
                </div>
            </div>
            <div className="mt-5 grid grid-cols-1 md:grid-cols-2 gap-2" data-testid="missing-email-list">
                {rows.map((it) => {
                    const key = `${it.kind}-${it.id}`;
                    const bday = it.kind === "birthday";
                    return (
                        <Link key={key} to={`/employees/${it.id}`} data-testid={`missing-email-${key}`}
                            className="group flex items-center gap-3 rounded-xl border border-ink/10 p-3 hover:border-klein/40 transition-colors">
                            {bday ? <Cake className="w-4 h-4 text-terracotta-500 shrink-0" /> : <Award className="w-4 h-4 text-amber-600 shrink-0" />}
                            <div className="min-w-0 flex-1">
                                <div className="text-sm font-semibold text-ink truncate">{it.name}</div>
                                <div className="text-xs text-ink/55 truncate">
                                    {bday ? "Birthday" : `${it.years}-year anniversary`} · {when(it.in_days)}{it.department ? ` · ${it.department}` : ""}
                                </div>
                            </div>
                            <span className="inline-flex items-center gap-1 text-xs font-semibold text-klein whitespace-nowrap">
                                Add email <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
                            </span>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
}
